import React from 'react'
import FilterItem from './FilterItem'
import getOtherFilters from '../../functions/getOtherFilters'
import Translation from '../../General/Translation'

const SearchFilter = ({
    queryStringValues,
    searchFilter,
    filterStrings,
    allItems,
    translation
}) => {
    if(!queryStringValues || !queryStringValues.search) {
        return ''
    }

    const filterId = 'search'
    const otherFilters = _.omit(filterStrings, filterId)


    let sortValue = getOtherFilters(otherFilters, null)

    const itemsToDisplay = _.intersection(searchFilter.items, allItems)
    const active = itemsToDisplay.length > 0


    return (
        <ul className="filter-section">
            <FilterItem
                filterId={filterId}
                itemName={<Translation id="search" trans={translation} after={': ' + queryStringValues.search}/>}
                className={active ? ' filter-active accent-color-button-font-color' : ''}
                active={active}
                sortValue={sortValue}
            />
        </ul>
    )
}

export default SearchFilter